import React from 'react'

export default function DetelEbike() {
    return (
        <div>
            <div className="carousel slide" data-bs-ride="carousel">
                <div className="carousel-inner">
                    <div className="carousel-item active">
                        <img src="assets/images/detel-banner.jpg" className="d-none d-md-block w-100 img-fluid"
                            style={{ height: '70vh' }} alt="..." />
                        <img src="assets/images/detel-banner-mobile-1.jpg" className="d-block d-md-none w-100 img-fluid"
                            alt="..." />
                        <div className="carousel-caption d-none d-md-block text-dark">
                            <h2 className="detelHeading">Amosta Presents</h2>
                            <br />
                            <h1 className="detelHeading1">Electric Bike</h1>
                            <br />
                            <a href="#section" type="button" className="btn btn-lg btn-success">BUY NOW
                            </a>
                        </div>
                        
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="container mt-5 text-center">
                    <div className="conatiner">
                        <p align="justify" style={{ fontSize: 'large' }}>Electric vehicles are soon going to be the future because of
                            high number of young population in India, also the fact that it is cost effective and does not add to
                            the urban pollution, makes it a desirable and affordable alternative to other
                            2 wheelers.
                        </p>

                        <h3>Bring Convenience Home</h3>
                        <div className="d-flex justify-content-center">
                            <h5 className="px-2" style={{ backgroundColor: '#e9e9e9' }}>#Deteldecarboniseindia</h5>
                        </div>
                    </div>
                </div>
                <div className="container mt-5 text-center">
                    <h2 className="detelHeading1">What Are We Providing</h2>
                    <div className="row mt-4">
                        <div className="col-md-4 col-lg-4 col-sm-12 mt-2">
                            <img className="img-fluid what-provide" src="assets/images/No_registration_no_Licences.jpg" alt="" />
                        </div>
                        <div className="col-md-4 col-lg-4 col-sm-12 mt-2">
                            <img className="img-fluid what-provide" src="assets/images/No_registration_Licence_Maintenance.jpg"
                                alt="" />
                        </div>
                        <div className="col-md-4 col-lg-4 col-sm-12 mt-2">
                            <img className="img-fluid what-provide" src="assets/images/Charge_Anywhere.jpg" alt="" />
                        </div>
                    </div>
                </div>

                <div className="container mt-5">
                    <div className="text-center">
                        <h2 className="detelHeading1">Features</h2>
                    </div>
                    <div className="container">
                        <div className="card border-0">
                            <div className="row mt-4">
                                <div className="col-md-3 col-lg-3 col-sm-12 mt-2 order-md-2">
                                    <img className="img-fluid what-provide" src="assets/images/detel-headlamp.png" alt="" />
                                </div>
                                <div className="col-md-9 col-lg-9 col-sm-12 mt-2 order-md-1" style={{ paddingTop: '50px' }}>
                                    <h3 align="justify">BATTERY</h3>
                                    <p align="justify">The powerhouse of an e-bike, Our Li-ion batteries are BIS certified and IP67
                                        rating makes them water repellent and provides 100% dust protection, to ensure you ride
                                        carefree in all weathers.
                                    </p>
                                </div>
                            </div>
                            <div className="card border-0 shadow-none">
                                <div className="row mt-4">
                                    <div className="col-md-3 col-sm-12 mt-2 order-md-1">
                                        <img className="img-fluid what-provide" src="assets/images/detel-motor.png" alt="" />
                                    </div>
                                    <div className="col-md-9 col-sm-12 mt-4 order-md-2" style={{ paddingTop: '50px' }}>
                                        <h3 align="justify">MOTOR</h3>
                                        <p align="justify">Our e-bikes come fitted with a high torque, 250W BLDC motor. Highly
                                            efficient and more torque per watt. Powerful performance with silent operation and a
                                            longer life.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="card border-0 shadow-none">
                                <div className="row mt-4">
                                    <div className="col-md-3 col-sm-12 mt-2 order-md-2">
                                        <img className="img-fluid what-provide" src="assets/images/detel-digital-meter.png" alt="" />
                                    </div>
                                    <div className="col-md-9 col-sm-12 mt-2 order-md-1" style={{ paddingTop: '50px' }}>
                                        <h3 align="justify">DIGITAL METER</h3>
                                        <p align="justify">Manage all functions of your e-bike with the handy LED display. Switch
                                            the battery on-off or toggle between 4 modes, the IP65 rated display does it all
                                            eamlessly in all weathers.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="card border-0 shadow-none">
                                <div className="row mt-4">
                                    <div className="col-md-3 col-sm-12 order-md-1">
                                        <img className="img-fluid what-provide" src="assets/images/detel-battery.png" alt="" />
                                    </div>
                                    <div className="col-md-9 col-sm-12 mt-4 order-md-2" style={{ paddingTop: '50px' }}>
                                        <h3 align="justify">HEADLAMP</h3>
                                        <p align="justify">Fit your e-bike with the LED headlamp and never go dark again. With the
                                            high intensity lumination you receive from the headlamp, riding early mornings or late
                                            nights gets easier.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container mt-5 text-center">
                    <h2 className="detelHeading1 mb-5">Specifications</h2>

                    <div className="row row-cols-2 row-cols-sm-4 g-5 justify-content-center">
                        <div className="col">
                            <div className="card specification-card">
                                <div className="card-body">
                                    <h6 className="card-title">Motor Rated Power</h6>
                                    <p className="card-text"><small>250 Watts</small></p>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card specification-card">
                                <div className="card-body">
                                    <h6 className="card-title">Battery Capacity</h6>
                                    <p className="card-text"><small>48V 20Ah Battery</small></p>
                                </div>
                            </div>

                        </div>
                        <div className="col">
                            <div className="card specification-card">
                                <div className="card-body">
                                    <h6 className="card-title">Range</h6>
                                    <p className="card-text"><small>60Km / Charge *</small></p>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card specification-card">
                                <div className="card-body">
                                    <h6 className="card-title">Battery location</h6>
                                    <p className="card-text"><small>Below the seat</small></p>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card specification-card">
                                <div className="card-body">
                                    <h6 className="card-title">Tyre</h6>
                                    <p className="card-text"><small>Tubeless (16"X2.5")</small></p>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card specification-card">
                                <div className="card-body">
                                    <h6 className="card-title">Body</h6>
                                    <p className="card-text"><small>Metal alloy and Powder coated</small></p>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card specification-card">
                                <div className="card-body">
                                    <h6 className="card-title">Pedals</h6>
                                    <p className="card-text"><small>Available</small></p>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card specification-card">
                                <div className="card-body">
                                    <h6 className="card-title">Brake</h6>
                                    <p className="card-text"><small>Drum System</small></p>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card specification-card">
                                <div className="card-body">
                                    <h6 className="card-title">Speed</h6>
                                    <p className="card-text"><small>Rated 25 Kmph</small></p>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card specification-card">
                                <div className="card-body">
                                    <h6 className="card-title">Charger</h6>
                                    <p className="card-text"><small>5 Ampere</small></p>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card specification-card">
                                <div className="card-body">
                                    <h6 className="card-title">Grounds clearance</h6>
                                    <p className="card-text"><small>170mm</small></p>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card specification-card">
                                <div className="card-body">
                                    <h6 className="card-title">Load capacity</h6>
                                    <p className="card-text"><small>170 Kg</small></p>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card specification-card">
                                <div className="card-body">
                                    <h6 className="card-title">Battery Type</h6>
                                    <p className="card-text"><small>Lithium Ion Battery</small></p>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card specification-card">
                                <div className="card-body">
                                    <h6 className="card-title">Meter</h6>
                                    <p className="card-text"><small>Digital Meter</small></p>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card specification-card">
                                <div className="card-body">
                                    <h6 className="card-title">Warranty</h6>
                                    <p className="card-text"><small>1 Year</small></p>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card specification-card" id="section">
                                <div className="card-body">
                                    <h6 className="card-title">Battery warranty</h6>
                                    <p className="card-text"><small>Upto 2 Years *</small></p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div className="container mt-5 mb-5 text-center">

                    <div className="row">
                        <div className="item col-md-3 col-lg-3 col-sm-6 mt-3">
                            <a href="assets/images/detel-red-1.png" className="fancybox" data-fancybox="gallery">
                                <img className="img-fluid gallery-image" src="assets/images/detel-red-1.png" width="100%"
                                    height="100%" alt='' />
                            </a>
                        </div>
                        <div className="item col-md-3 col-lg-3 col-sm-6 mt-3">
                            <a href="assets/images/detel-red-2.png" className="fancybox" data-fancybox="gallery">
                                <img className="img-fluid gallery-image" src="assets/images/detel-red-2.png" width="100%"
                                    height="100%" alt='' />
                            </a>
                        </div>
                        <div className="item col-md-3 col-lg-3 col-sm-6 mt-3">
                            <a href="assets/images/detel-red-3.png" className="fancybox" data-fancybox="gallery">
                                <img className="img-fluid gallery-image" src="assets/images/detel-red-3.png" width="100%"
                                    height="100%" alt='' />
                            </a>
                        </div>
                        <div className="item col-md-3 col-lg-3 col-sm-6 mt-3">
                            <a href="assets/images/detel-red-4.png" className="fancybox" data-fancybox="gallery">
                                <img className="img-fluid gallery-image" src="assets/images/detel-red-4.png" width="100%"
                                    height="100%" alt='' />
                            </a>
                        </div>
                        <div className="item col-md-3 col-lg-3 col-sm-6 mt-3">
                            <a href="assets/images/detel-red-5.png" className="fancybox" data-fancybox="gallery">
                                <img className="img-fluid gallery-image" src="assets/images/detel-red-5.png" width="100%"
                                    height="100%" alt='' />
                            </a>
                        </div>
                        <div className="item col-md-3 col-lg-3 col-sm-6 mt-3">
                            <a href="assets/images/detel-red-6.png" className="fancybox" data-fancybox="gallery">
                                <img className="img-fluid gallery-image" src="assets/images/detel-red-6.png" width="100%"
                                    height="100%" alt='' />
                            </a>
                        </div>
                        <div className="item col-md-3 col-lg-3 col-sm-6 mt-3">
                            <a href="assets/images/detel-silver-1.png" className="fancybox" data-fancybox="gallery">
                                <img className="img-fluid gallery-image" src="assets/images/detel-silver-1.png" width="100%"
                                    height="100%" alt='' />
                            </a>
                        </div>
                        <div className="item col-md-3 col-lg-3 col-sm-6 mt-3">
                            <a href="assets/images/detel-silver-2.png" className="fancybox" data-fancybox="gallery">
                                <img className="img-fluid gallery-image" src="assets/images/detel-silver-2.png" width="100%"
                                    height="100%" alt='' />
                            </a>
                        </div>
                        <div className="item col-md-3 col-lg-3 col-sm-6 mt-3">
                            <a href="assets/images/detel-silver-3.png" className="fancybox" data-fancybox="gallery">
                                <img className="img-fluid gallery-image" src="assets/images/detel-silver-3.png" width="100%"
                                    height="100%" alt='' />
                            </a>
                        </div>
                        <div className="item col-md-3 col-lg-3 col-sm-6 mt-3">
                            <a href="assets/images/detel-silver-4.png" className="fancybox" data-fancybox="gallery">
                                <img className="img-fluid gallery-image" src="assets/images/detel-silver-4.png" width="100%"
                                    height="100%" alt='' />
                            </a>
                        </div>
                        <div className="item col-md-3 col-lg-3 col-sm-6 mt-3">
                            <a href="assets/images/detel-silver-5.png" className="fancybox" data-fancybox="gallery">
                                <img className="img-fluid gallery-image" src="assets/images/detel-silver-5.png" width="100%"
                                    height="100%" alt='' />
                            </a>
                        </div>
                        <div className="item col-md-3 col-lg-3 col-sm-6 mt-3">
                            <a href="assets/images/detel-silver-6.png" className="fancybox" data-fancybox="gallery">
                                <img className="img-fluid gallery-image" src="assets/images/detel-silver-6.png" width="100%"
                                    height="100%" alt='' />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="carousel slide mt-5" data-bs-ride="carousel">
                <div className="carousel-inner">
                    <div className="carousel-item active">
                        <img src="assets/images/detel-banner-2.jpg" className="d-none d-md-block w-100 img-fluid"
                            style={{height:'40vh'}} alt="..." />
                            <img src="assets/images/detel-banner-mobile-2.jpg" className="d-block d-md-none w-100 img-fluid"
                                alt="..." />
                            </div>
                    </div>
                </div>
            </div>
            )
}
